<script setup>
import { Head, Link } from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import SideBar from '@/Components/SideBar';
import PropertyCard from '@/Components/PropertyCard';
import Pagination from '@/Components/Pagination';
import { Inertia } from '@inertiajs/inertia'

defineProps({
    properties: Object,
    property_statuses: Object,
    property_types: Object,
    property_interior: Object,
    property_locations: Object,
});

</script>

<script>
export default {
    data(){
        return {
            search: '',
            status: [],
            type: [],
            interior: [],
            location: [],
            sort_by: '',
            bedroom: [],
            area: '',
            price: ''
        }
    },
    components: {
        Pagination,
    },
    mounted(){
        this.sort_by = (route().params.search != undefined && route().params.sort_by != '') ? route().params.sort_by : '';

        if(route().current() == 'buy'){
            document.querySelector('section.page-header').style.background = 'url("' + this.asset('/images/backgrounds/background-image-4.jpg') + '")';
        }
        else if(route().current() == 'rent'){
            document.querySelector('section.page-header').style.background = 'url("' + this.asset('/images/backgrounds/background-image-5.jpg') + '")';
        }
        else{
            document.querySelector('section.page-header').style.background = 'url("' + this.asset('/images/backgrounds/background-image-6.jpg') + '")';
        }

        document.querySelector('section.page-header').style.backgroundRepeat = 'no-repeat';
        document.querySelector('section.page-header').style.backgroundSize = 'cover';
        document.querySelector('section.page-header').style.backgroundPosition = 'center';

        Array.from(document.getElementsByClassName('dropdown-toggle')).forEach(element => {
            element.addEventListener('click', function(e){
                let x = e.currentTarget.nextElementSibling;
                if(x){
                    if(x.classList.contains('show')){
                        x.classList.remove('show');
                    }
                    else{
                        Array.from(document.getElementsByClassName('dropdown-menu')).forEach(el => {
                            el.classList.remove("show");
                        });
                        x.classList.add('show');
                    }
                }
            });
        });

        emitter.on('filterUpdated', data => {
            this.search = (data.search) ? data.search : '';
            this.status = (data.status) ? data.status : [];
            this.type = (data.type) ? data.type : [];
            this.interior = (data.interior) ? data.interior : [];
            this.sort_by = (data.sort_by != undefined) ? data.sort_by : this.sort_by;
            this.bedroom = (data.bedroom) ? data.bedroom : [];
            this.area = (data.area != undefined) ? {from: data.area.from, to: data.area.to} : '';
            this.price = (data.price != undefined) ? {from: data.price.from, to: data.price.to} : '';
            
            if(route().current() == 'buy'){
                Inertia.visit(this.route('buy', { 
                    search: this.search,
                    status: (this.status && this.status.length > 0) ? this.status.join(',') : '',
                    type: (this.type && this.type.length > 0) ? this.type.join(',') : '',
                    interior: (this.interior && this.interior.length > 0) ? this.interior.join(',') : '',
                    location: (this.location && this.location.length > 0) ? this.location.join(',') : '',
                    sort_by: this.sort_by,
                    bedroom: (this.bedroom && this.bedroom.length > 0) ? this.bedroom.join(',') : '',
                    area: (this.area) ? this.area.from + ',' + this.area.to : '',
                    price: (this.price) ? this.price.from + ',' + this.price.to : '',
                }))
            }
            else if(route().current() == 'rent'){
                Inertia.visit(this.route('rent', { 
                    search: this.search,
                    status: (this.status && this.status.length > 0) ? this.status.join(',') : '',
                    type: (this.type && this.type.length > 0) ? this.type.join(',') : '',
                    interior: (this.interior && this.interior.length > 0) ? this.interior.join(',') : '',
                    location: (this.location && this.location.length > 0) ? this.location.join(',') : '',
                    sort_by: this.sort_by,
                    bedroom: (this.bedroom && this.bedroom.length > 0) ? this.bedroom.join(',') : '',
                    area: (this.area) ? this.area.from + ',' + this.area.to : '',
                    price: (this.price) ? this.price.from + ',' + this.price.to : '',
                }))
            }
            else{
                Inertia.visit(this.route('international-properties', { 
                    search: this.search,
                    status: (this.status && this.status.length > 0) ? this.status.join(',') : '',
                    type: (this.type && this.type.length > 0) ? this.type.join(',') : '',
                    interior: (this.interior && this.interior.length > 0) ? this.interior.join(',') : '',
                    location: (this.location && this.location.length > 0) ? this.location.join(',') : '',
                    sort_by: this.sort_by,
                    bedroom: (this.bedroom && this.bedroom.length > 0) ? this.bedroom.join(',') : '',
                    area: (this.area) ? this.area.from + ',' + this.area.to : '',
                    price: (this.price) ? this.price.from + ',' + this.price.to : '',
                }))
            }
        });
    },
    methods: {

        sortBy: function(sort){
            emitter.emit('filterUpdated', {
                search: this.search,
                status: this.status,
                type: this.type,
                interior: this.interior,
                location: this.location,
                sort_by: sort,
                bedroom: this.bedroom,
                area: this.area,
                price: this.price
            });
        },

        resetFilters: function(){
            this.search = '';
            this.status = [];
            this.type = [];
            this.interior = [];
            this.location = [];
            this.sort_by = '';
            this.bedroom = [];
            this.area = {
                            from: 200,
                            to: 8000
                        };
            this.price = {
                            from: 20000,
                            to: 300000
                        };

            emitter.emit('filterUpdated', {
                search: this.search,
                status: this.status,
                type: this.type,
                interior: this.interior,
                location: this.location,
                sort_by: ''
            });
        },

        toggleMobileFilter(){
            if(document.querySelector('.properties-filter').classList.contains('opened')){
                document.querySelector('.properties-filter').classList.remove('opened')
            }
            else{
                document.querySelector('.properties-filter').classList.add('opened')
            };
        }
    }
}
</script>


<template>
    <AppLayout title="Buy / Sell / Rent Properties" desc="Discovers a wide range of properties in Dubai and UAE with Inspire Properties">
        <template #header>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);">{{ route().current() == 'buy' ? 'Buy' : (route().current() == 'rent' ? 'Rent' : 'International Properties') }}</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Propety Listing</li>
                </ol>
            </nav>
            <div>
                <h1 class="page-header-heading">{{ route().current() == 'buy' ? 'Buy A Property' : (route().current() == 'rent' ? 'Rent A Property' : 'International Properties') }}</h1>
            </div>
        </template>
        <section class="property-filters">
            <div class="container p-2 p-sm-0 p-lg-auto">
                <SideBar :sortBy="sort_by" :property_statuses="property_statuses" :property_types="property_types" :property_interior="property_interior" :property_locations="property_locations"></SideBar>
                <div class="sort mt-2 d-flex flex-column flex-md-row justify-content-between px-lg-2 mx-1">
                    <h3 class="order-1 order-md-0 pt-2 pt-lg-auto mt-4 mt-md-2">We Found <span>{{ properties.total }}</span> Properties Available For You.</h3>
                    <div class="d-flex order-0 order-md-1 justify-content-start">
                        <button class="d-lg-none me-2" type="button" @click="toggleMobileFilter()">Filters</button>
                        <button class="me-2" @click="resetFilters()" type="button">Reset</button>
                        <div class="dropdown">
                            <button class= "dropdown-toggle" type="button" id="sortByMenu" aria-expanded="false" :class="sort_by ? 'filter-active' : ''">
                                {{ sort_by != '' ? (sort_by == 'area-high' ? 'Higher Area' : (sort_by == 'area-low' ? 'Lower Area' : 'Name')) : 'Sort' }}
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                                    </svg>
                                </span>
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="sortByMenu">
                                <li><a class="dropdown-item" href="javascript:void(0);" @click="sortBy('name')">Name</a></li>
                                <li><a class="dropdown-item" href="javascript:void(0);" @click="sortBy('area-high')">Higher Area</a></li>
                                <li><a class="dropdown-item" href="javascript:void(0);" @click="sortBy('area-low')">Lower Area</a></li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div> 
        </section>
        <section class="property-listing">
            <div class="container">
                <div class="property-list-wrapper" v-if="properties.data.length > 0">
                    <div class="row">
                        <div class="col-sm-6 col-lg-4 px-sm-1 px-lg-0 px-xl-3 mt-lg-2" v-for="property in properties.data" :key="property.id">
                            <PropertyCard :property="property" class="m-lg-2 m-xl-auto" />
                        </div>  
                    </div>
                    <div class="my-5 d-flex justify-content-center">
                        <Pagination :links="properties.links" />
                    </div>
                </div>
                <div class="property-list-wrapper" v-else>
                    <div class="row justify-content-center py-5">
                        <div class="col-lg-6 text-center py-5 my-5">
                            <h2 class="na">No Properties Found</h2>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div id="filters-sidebar" class="d-none d-lg-none">
            <button @click="toggleMobileFilter()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-funnel" viewBox="0 0 16 16">
                    <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2h-11z"/>
                </svg>
                <span class="ps-2">Filter</span>
            </button>
        </div>
        
    </AppLayout>
</template>

<style scoped>
.property-filters .dropdown-item.active, .property-filters .dropdown-item:active, .property-filters .dropdown-item:hover{
    background-color: var(--secondary-color) !important;
}

.na{
    color: #43505c;
}
</style>